export function orderStatusColorVariant(value) {
  switch ((value || '').toLowerCase()) {
    case 'draft': return 'light';
    case 'finalized': return 'success';
    case 'done': return 'dark';
    default: return 'light';
  }
}



// WEBPACK FOOTER //
// ./src/sales/filters/statuses.js